/**
 * Star row builder, shared by cs-reviews.js and cs-reviews-strip.js.
 *
 * Extracted because this markup already had to be corrected in three separate
 * copies once (cs-stars.liquid, cs-review-summary.liquid and cs-reviews.js) and
 * a fourth copy was about to be written. Keep it in step with cs-stars.liquid
 * and Stars.tsx.
 *
 * text-foreground on the wrapper is deliberate and is what Stars.tsx does. On
 * the ink review cards that makes the outline ink-on-ink, so empty stars are
 * invisible and only the green fills read — which is how the live site renders.
 */
window.csStars = (function () {
  const stars = (score, size) => {
    let out = `<span class="inline-flex items-center gap-0.5 text-foreground" role="img" aria-label="${score} out of 5 stars">`;
    for (let i = 0; i < 5; i++) {
      const pct = Math.max(0, Math.min(1, score - i)) * 100;
      out +=
        `<span class="relative inline-block" style="width:${size}px;height:${size}px">` +
        `<span class="absolute inset-0 overflow-hidden" style="width:${pct}%">` +
        `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="hsl(var(--primary))" stroke="none" data-star-fill aria-hidden="true" class="block"><polygon points="12,2 15,9 22,9.5 16.5,14.5 18.5,22 12,18 5.5,22 7.5,14.5 2,9.5 9,9"/></svg>` +
        `</span>` +
        `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true" class="block relative z-10"><polygon points="12,2 15,9 22,9.5 16.5,14.5 18.5,22 12,18 5.5,22 7.5,14.5 2,9.5 9,9"/></svg>` +
        `</span>`;
    }
    return out + '</span>';
  };

  /** Matches truncateReviewBody() in the React component. */
  return stars;
})();
